const illustrationImage = [
    ('https://trillfront.s3.ap-southeast-1.amazonaws.com/img/ill1.png'),
    ('https://trillfront.s3.ap-southeast-1.amazonaws.com/img/ill2.png'),
    ('https://trillfront.s3.ap-southeast-1.amazonaws.com/img/ill3.png'),
];

export default illustrationImage;